// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Tooltip = require("./Tooltip.bs.js");
let AgentInfo = require("./AgentInfo.bs.js");
let ButtonsV5 = require("./ButtonsV5.bs.js");
let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let OwnAnonymousAgentInfo_agent_graphql = require("../../../__generated__/OwnAnonymousAgentInfo_agent_graphql.bs.js");

let convertFragment = OwnAnonymousAgentInfo_agent_graphql.Internal.convertFragment;

function OwnAnonymousAgentInfo(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "xSmall";
  let agent = RescriptRelay_Fragment.useFragment(OwnAnonymousAgentInfo_agent_graphql.node, convertFragment, props.agent);
  let match = agent.profilePhoto;
  let avatar = match !== undefined ? match.url : AvatarSrcUrl.place_holder;
  return JsxRuntime.jsx(AgentInfo.Presentation.make, {
    avatar: avatar,
    size: size,
    name: agent.displayName,
    brokerage: agent.brokerage,
    wrapName: name => JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(ButtonsV5.Link.make, {
          href: `/agents/` + agent.id,
          onClick: e => {
            e.stopPropagation();
          },
          children: JsxRuntime.jsx("div", {
            children: name,
            className: size === "xxSmall" ? "font-normal" : "font-medium"
          })
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Tooltip.make, {
            label: "This is only visible to you because you posted this property.  Other agents will not see your name, photo or brokerage.",
            children: JsxRuntime.jsx("span", {
              children: "Only visible to you",
              className: "underline decoration-dotted"
            })
          }),
          className: "font-normal text-sm text-zinc-500"
        })
      ],
      className: "flex flex-col gap-1"
    }),
    children: null
  });
}

let make = OwnAnonymousAgentInfo;

exports.make = make;
/* Tooltip Not a pure module */
